module.exports = function(app) {
    app.directive('accountDrawer', ['sessionData', function(sessionData) {
        return {
            restrict: 'A',
            //template: require('directives/spending/accountDrawer.html'),
            templateUrl: 'spending.appTemplate.html/chmhom/directives/spending/accountDrawer',
            scope: {
                account: '=accountDrawer'

            },
            link: function(scope){

            },
            controller: ['sessionData', '$scope', '$state', 'services',  'modal', 'storage', '$timeout',  '$q', 'coremetrics', 'session', 'brand','$location','spaUtil','$window',
                function(sessionData, $scope, $state, services, modal, storage, $timeout,  $q, coremetrics, session, brand,$location,spaUtil,$window) {
                    var spendingAccountInfo = $scope.account;
                    $scope.shouldShowEmployerLine=false;
                    if(sessionData.memberInfo && sessionData.memberInfo.clientList.length >=2){
                        $scope.shouldShowEmployerLine=true;
                    }

                    $scope.showNewClaimButton =function(){
                        return $location.url().indexOf("newClaims")>-1;
                    }
                    $scope.accessAccountdetails=function(clientNumber){
                        var thePayload = {
                            groupId: clientNumber,
                            memberId: sessionData.memberInfo.umi,
                            csr: false,
                            DLParams: 'obj~EEPRFLSMRYPAGE-Page',
                            userRole: 'MEMBER'
                        };

                        coremetrics.elementTag('MEMBER:SPENDING:ACCLARIS SSO', 'MEMBER:SPENDINGLMANAGE SPENDING ACCOUNTS');

                        spaUtil.acclarisSSO(thePayload);

                    }

                    $scope.goToSpendingAccountSettings =function(){
                        var SASdata = {};
                        SASdata.participantCode = sessionData.memberInfo.umi;
                        SASdata.groupCode = spendingAccountInfo.groupCode;
                        SASdata.accountType = spendingAccountInfo.accountType;
                        SASdata.cancelledAcct = spaUtil.isCancelledAccount(spendingAccountInfo);
                        SASdata.futureAcct = spaUtil.isFutureAccount(spendingAccountInfo);
                        storage.set('SASdata',SASdata);
                        $window.location="/member/spending/spendingAccountSettings";

                    };
                    $scope.submitClaims = function() {
                        sessionStorage.incomingUrl = "claim";
                        $window.location = '/member/spending/clientListSelection';
                    };

                }
            ]
        };
    }]);


};